import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/leftArrowIcon.svg'


const _hoisted_1 = { class: "maincontainer pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "lg:flex justify-between mt-5" }
const _hoisted_3 = { class: "bg-white sm:mb-2 lg:mb-0 mr-3 flex justify-center items-center h-17 rounded w-full border border-primary" }
const _hoisted_4 = { class: "text-center mt-1 text-primary font-semibold text-lg" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex rounded items-center regular text-sm" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-sm font-normal text-center" }
const _hoisted_9 = { class: "mt-1 text-center font-semibold text-lg" }
const _hoisted_10 = { class: "totalContentContainer relative min-lg:flex min-lg:justify-between p-4 rounded bg-white border border-lightgrey mt-10" }
const _hoisted_11 = { class: "graphContainerHeat initialWidthGraphs mt-4 lg:pl-0 max-2xl:w-1/2" }
const _hoisted_12 = { class: "flex pl-20 mb-5" }
const _hoisted_13 = ["onMouseover"]
const _hoisted_14 = { class: "text-xs pl-1" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex flex-col gap-10 pt-4" }
const _hoisted_17 = { class: "axisLabel" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-black bg-lightgrey rounded-full h-5 w-5 flex justify-center items-center text-xs font-bold" }
const _hoisted_20 = { class: "flex mt-2 justify-between" }
const _hoisted_21 = { class: "axisLabel" }
const _hoisted_22 = { class: "lg:ml-4 initialTableWidth" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "totalContentContainer max-lg:h-full relative min-lg:flex min-lg:justify-between p-4 rounded bg-white border border-lightgrey mt-10" }
const _hoisted_26 = { class: "graphContainerTri initialWidthGraphs" }
const _hoisted_27 = { class: "tierTriangleMapContainer mt-4 pl-5 lg:pl-0 max-2xl:w-1/2" }
const _hoisted_28 = { class: "container my-3" }
const _hoisted_29 = { class: "triangleShape" }
const _hoisted_30 = { class: "backgroundDiv" }
const _hoisted_31 = { class: "tierMapBackgroundBorder" }
const _hoisted_32 = { class: "bgLayer1 font-extrabold pr-3 flex justify-end items-center" }
const _hoisted_33 = { class: "bgLayer2 font-extrabold pr-3 flex justify-end items-center" }
const _hoisted_34 = { class: "bgLayer3 font-extrabold pr-3 flex justify-end items-center" }
const _hoisted_35 = { class: "custom-shape bg-black flex justify-center items-center text-white" }
const _hoisted_36 = { class: "border-span" }
const _hoisted_37 = { class: "lg:ml-4 initialTableWidth" }
const _hoisted_38 = { class: "text-base font-semibold text-center mt-2" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  id: "DonutContainer",
  class: "totalContentContainer relative min-lg:flex min-lg:justify-between p-3 rounded bg-white border border-lightgrey mt-10"
}
const _hoisted_42 = { class: "flex items-center initialWidthGraphs mt-4 pl-5 lg:pl-0 max-2xl:justify-center" }
const _hoisted_43 = { id: "chart" }
const _hoisted_44 = { class: "lg:ml-4 initialTableWidth" }
const _hoisted_45 = { class: "text-base font-semibold text-center mt-2" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  id: "severityTable",
  class: "filterRisksContainer relative flex p-3 rounded bg-white border border-lightgrey mt-4"
}
const _hoisted_48 = { class: "ml-1 w-full" }
const _hoisted_49 = { class: "flex justify-between mt-3" }
const _hoisted_50 = { class: "w-28 mr-5 h-7" }
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  id: "statusTable",
  class: "filterRisksContainer relative flex p-3 rounded bg-white border border-lightgrey mt-4"
}
const _hoisted_55 = { class: "ml-1 w-full" }
const _hoisted_56 = { class: "flex justify-between mt-3" }
const _hoisted_57 = { class: "w-28 h-7 mr-5" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  id: "deptTable",
  class: "filterRisksContainer relative flex p-3 rounded bg-white border border-lightgrey mt-4"
}
const _hoisted_62 = { class: "ml-1 w-full" }
const _hoisted_63 = { class: "flex justify-between mt-3" }
const _hoisted_64 = { class: "w-32 h-7 mr-5" }
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  id: "ageTable",
  class: "filterRisksContainer relative flex p-3 rounded bg-white border border-lightgrey mt-4"
}
const _hoisted_69 = { class: "ml-1 w-full" }
const _hoisted_70 = { class: "flex justify-between mt-3" }
const _hoisted_71 = { class: "mr-5 w-2/3 flex justify-end" }
const _hoisted_72 = { class: "w-32 h-7 mr-2" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "w-40 h-7 mr-5" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  id: "timePeriodTable",
  class: "filterRisksContainer relative flex p-3 rounded bg-white border border-lightgrey mt-4"
}
const _hoisted_80 = { class: "ml-1 w-full" }
const _hoisted_81 = { class: "flex justify-between mt-3" }
const _hoisted_82 = { class: "mr-5 w-2/3 flex justify-end" }
const _hoisted_83 = { class: "w-32 h-7 mr-3" }
const _hoisted_84 = ["max"]
const _hoisted_85 = { class: "w-32 h-7" }
const _hoisted_86 = ["disabled", "max"]
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[44] || (_cache[44] = _createElementVNode("h1", { class: "h-8 flex items-center" }, "Dashboard", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-sm font-normal px-2 text-primary" }, "Total Risks", -1)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.TotalRisksCount), 1)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riskStatusValue, (pair) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pair,
          onClick: ($event: any) => (_ctx.getRisksFromLabel(pair.id)),
          class: _normalizeClass(["mr-3 sm:mb-2 lg:mb-0 cursor-pointer flex relative justify-center items-center indicateBoxes h-17 rounded w-full border", _ctx.colorRiskText(pair.id)])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full h-full absolute rounded", _ctx.colorRiskBg(pair.id)])
          }, null, 2),
          _createElementVNode("div", _hoisted_6, [
            (!isNaN(pair.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(pair.value), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.getCount(pair.id)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "heatMapOrganisation flex items-center justify-center ml-2 absolute bg-white rounded border border-lightgrey" }, [
        _createElementVNode("p", { class: "text-base font-semibold text-center" }, "Heat Map - Organization")
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorData, (obj) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "px-2",
              key: obj.value
            }, [
              _createElementVNode("div", {
                class: "flex justify-center items-center cursor-pointer",
                onMouseover: ($event: any) => (_ctx.hoverColor(obj.id)),
                onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leaveColor()))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-3 w-3 rounded-full", obj.color])
                }, null, 2),
                _createElementVNode("div", _hoisted_14, _toDisplayString(obj.value), 1)
              ], 40, _hoisted_13)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex flex-col w-3 justify-center likelihoodLabel pr-12" }, [
            _createElementVNode("p", { class: "font-bold text-lg" }, "Likelihood")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLikelihood, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value
              }, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(item.key), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grid, (row, rowIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: rowIndex,
                class: "flex"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, colIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: colIndex,
                    class: _normalizeClass([_ctx.getColor(cell.x, cell.y), "flex items-center cursor-default justify-center heatmapBox"]),
                    onClick: ($event: any) => (_ctx.getZonalRisks(cell.x,cell.y))
                  }, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(cell.value), 1)
                  ], 10, _hoisted_18))
                }), 128))
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOverAllImpact, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.value
                }, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(item.key), 1)
                ]))
              }), 128))
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mt-3 flex justify-center" }, [
              _createElementVNode("p", { class: "font-bold text-lg" }, "Impact")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.displayChartRisksListInTable,
            headersData: _ctx.headers1,
            openPopup: false,
            loadData1: _ctx.dataLoading1
          }, null, 8, ["tableRowData", "headersData", "loadData1"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "tierMapOrganisation flex items-center justify-center ml-2 absolute bg-white rounded border border-lightgrey" }, [
          _createElementVNode("p", { class: "text-base font-semibold text-center" }, "Tier Level Graph / Chart")
        ], -1)),
        _createElementVNode("div", _hoisted_27, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "strategicRisk" }, [
            _createElementVNode("h1", { class: "text-base font-bold text-center" }, "STRATEGIC RISK")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "tierMapBackgroundBorder1" }, null, -1)),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.getTierRisks(1)) + " Risks", 1),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.getTierRisks(2)) + " Risks", 1),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.getTierRisks(3)) + " Risks", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getTierLevelRisks(1))),
                    class: "layer layer1 bg-blue-350 text-center cursor-pointer flex justify-center font-semibold items-center border-b-2 border-black z-10"
                  }, _cache[28] || (_cache[28] = [
                    _createElementVNode("div", { class: "orgBorder mt-3" }, [
                      _createTextVNode("Tier 1"),
                      _createElementVNode("br"),
                      _createTextVNode("Organisation")
                    ], -1)
                  ])),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getTierLevelRisks(2))),
                    class: "layer layer2 cursor-pointer text-center flex justify-center items-center font-semibold border-b-2 border-black z-0"
                  }, _cache[29] || (_cache[29] = [
                    _createTextVNode("Tier 2"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("Business Process")
                  ])),
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTierLevelRisks(3))),
                    class: "layer layer3 cursor-pointer text-center flex justify-center items-center font-semibold"
                  }, _cache[30] || (_cache[30] = [
                    _createTextVNode(" Tier 3 "),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" System Level ")
                  ]))
                ])
              ])
            ])
          ]),
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "tacticalRisk" }, [
            _createElementVNode("h1", { class: "text-base font-bold text-center" }, "TACTICAL RISK")
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.getTierHeading(_ctx.selectedTier)), 1),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.tierLevelRiskData,
            headersData: _ctx.tierHeaders,
            openPopup: false,
            loadData2: _ctx.dataLoading2
          }, null, 8, ["tableRowData", "headersData", "loadData2"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "tierMapOrganisation flex items-center justify-center ml-2 absolute bg-white rounded border border-lightgrey" }, [
        _createElementVNode("p", { class: "text-base font-semibold text-center" }, "Priority Level Graph / Chart")
      ], -1)),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createVNode(_component_apexchart, {
            width: "400",
            type: "donut",
            options: _ctx.donutChartOptions,
            series: _ctx.series,
            onDataPointSelection: _ctx.clickOnDonutSlice
          }, null, 8, ["options", "series", "onDataPointSelection"])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("p", _hoisted_45, _toDisplayString('Priority Based Risk - ') + _toDisplayString(_ctx.selectedPriority), 1),
        _createVNode(_component_newTable, {
          tableRowData: _ctx.displayPriorityRiskList,
          headersData: _ctx.headers2,
          openPopup: false,
          loadData3: _ctx.dataLoading3
        }, null, 8, ["tableRowData", "headersData", "loadData3"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-base font-semibold text-center ml-5" }, "Risks - By Severity", -1)),
          _createElementVNode("div", _hoisted_50, [
            _withDirectives(_createElementVNode("select", {
              class: "inputboxstyling ml-3",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTopRisksData(1,_ctx.severityFilter))),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.severityFilter) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSeverity, (pair) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: pair,
                  value: pair.value
                }, _toDisplayString(pair.key), 9, _hoisted_51))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.severityFilter]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.displaySeverityRiskList,
            headersData: _ctx.headers2,
            openPopup: false,
            loadData3: _ctx.dataLoading3
          }, null, 8, ["tableRowData", "headersData", "loadData3"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-base font-semibold ml-5 text-center" }, "Risks - By Status", -1)),
          _createElementVNode("div", _hoisted_57, [
            _withDirectives(_createElementVNode("select", {
              class: "inputboxstyling",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getTopRisksData(2,_ctx.riskStatus))),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.riskStatus) = $event))
            }, [
              _cache[36] || (_cache[36] = _createElementVNode("option", {
                hidden: "",
                value: ""
              }, "Select", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riskStatusValue, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option,
                  value: option.id
                }, _toDisplayString(option.value), 9, _hoisted_58))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.riskStatus]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.displayStatusesRiskList,
            headersData: _ctx.headers2,
            openPopup: false,
            loadData3: _ctx.dataLoading3
          }, null, 8, ["tableRowData", "headersData", "loadData3"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-base font-semibold ml-5" }, "Risks - By Department", -1)),
          _createElementVNode("div", _hoisted_64, [
            _withDirectives(_createElementVNode("select", {
              class: "inputboxstyling",
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getTopRisksData(3,_ctx.deptName))),
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deptName) = $event))
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("option", {
                hidden: "",
                value: ""
              }, "Select", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departmentList, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option,
                  value: option.id
                }, _toDisplayString(option.value), 9, _hoisted_65))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.deptName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.displayDeptRiskList,
            headersData: _ctx.headers2,
            openPopup: false,
            loadData3: _ctx.dataLoading3
          }, null, 8, ["tableRowData", "headersData", "loadData3"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-base font-semibold ml-5" }, _toDisplayString("Risks - By Status & Age"), -1)),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _withDirectives(_createElementVNode("select", {
                class: "inputboxstyling ml-3",
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getTopRisksData(4,_ctx.ageFilter))),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.statusForAge) = $event))
              }, [
                _cache[40] || (_cache[40] = _createElementVNode("option", {
                  value: "",
                  hidden: ""
                }, "Select", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riskStatusValue, (pair) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: pair,
                    value: pair.id
                  }, _toDisplayString(pair.value), 9, _hoisted_73))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.statusForAge]
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["ml-3", {'disabledinputboxstyling disabledselect py-1.5':_ctx.statusForAge == '' ,'inputboxstyling px-1.5':_ctx.statusForAge != '' }]),
                disabled: _ctx.statusForAge == '',
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getTopRisksData(4,_ctx.ageFilter))),
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ageFilter) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AgeObject, (pair) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: pair,
                    value: pair.id
                  }, _toDisplayString(pair.value), 9, _hoisted_76))
                }), 128))
              ], 42, _hoisted_75), [
                [_vModelSelect, _ctx.ageFilter]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_77, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.displayAgeRiskList,
            headersData: _ctx.headers3,
            openPopup: false,
            loadData3: _ctx.dataLoading3
          }, null, 8, ["tableRowData", "headersData", "loadData3"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_79, [
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _cache[42] || (_cache[42] = _createElementVNode("p", { class: "text-base font-semibold w-1/3 ml-5" }, "Risks - By Time", -1)),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
                class: _normalizeClass(["inputboxstyling", {'focused': _ctx.isFocused}]),
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.startDate) = $event)),
                max: _ctx.maxDate,
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkDates(_ctx.startDate,_ctx.endDate)))
              }, null, 42, _hoisted_84), [
                [_vModelText, _ctx.startDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
                disabled: _ctx.startDate=='',
                max: _ctx.maxDate,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.endDate) = $event)),
                onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.getTopRisksData(5,[_ctx.startDate,_ctx.endDate]))),
                class: _normalizeClass({'disabledinputboxstyling py-1.5':_ctx.startDate=='','inputboxstyling':_ctx.startDate!='', 'focused': _ctx.isFocused})
              }, null, 42, _hoisted_86), [
                [_vModelText, _ctx.endDate]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createVNode(_component_newTable, {
            tableRowData: _ctx.displayTimePeriodRisks,
            headersData: _ctx.headers2,
            openPopup: false,
            loadData3: _ctx.dataLoading3
          }, null, 8, ["tableRowData", "headersData", "loadData3"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showBackToTop)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
          class: "back-to-top flex items-center justify-center"
        }, _cache[43] || (_cache[43] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "h-12 leftarrow absolute cursor-pointer"
          }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}